(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ig-marquee')) {
    class IgMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ig-mq__track');
        this.group = this.querySelector('.ig-mq__group');
        if (!this.track || !this.group || !this.group.children.length) return;

        this.originals = Array.from(this.group.children).map((el) => el.cloneNode(true));
        this.lastWidth = 0;
        this.build();

        this.ro = new ResizeObserver(() => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            if (Math.abs(this.clientWidth - this.lastWidth) > 20) this.build();
          }, 200);
        });
        this.ro.observe(this);
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        clearTimeout(this.timer);
      }

      hide(el) {
        el.setAttribute('aria-hidden', 'true');
        el.removeAttribute('data-shopify-editor-block');
        el.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
        el.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      }

      build() {
        this.classList.remove('is-ready');
        const viewport = this.clientWidth || window.innerWidth;
        this.lastWidth = viewport;

        // Reset
        while (this.track.children.length > 1) this.track.lastElementChild.remove();
        this.group.replaceChildren(...this.originals.map((el) => el.cloneNode(true)));

        // Repeat images until one set fills the screen width
        let guard = 0;
        while (this.group.scrollWidth < viewport && guard < 30) {
          this.originals.forEach((el) => {
            const c = el.cloneNode(true);
            this.hide(c);
            this.group.appendChild(c);
          });
          guard++;
        }

        // Duplicate the set for a seamless loop
        const copy = this.group.cloneNode(true);
        this.hide(copy);
        this.track.appendChild(copy);

        const speed = parseFloat(this.dataset.speed) || 40;
        const width = this.group.getBoundingClientRect().width;
        this.style.setProperty('--dur', (width / speed).toFixed(2) + 's');

        requestAnimationFrame(() => this.classList.add('is-ready'));
      }
    }
    customElements.define('ig-marquee', IgMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
